import { IssueOfflineService } from '~/sqlite/services/issue';

export class IssueLocalDataSource extends IssueOfflineService {}

export const issueLocal = new IssueLocalDataSource();
